 
<section *transloco="let transloco" class="payment-form__cc" [ngStyle]="{ 'position':'relative'}">  
 <app-local-loader-spinner id="localSpinner" [hidden]="visibleForm"></app-local-loader-spinner>
 <section [ngClass]="{ 'opacity-0 invisible': !visibleForm}" id="paymentForm">
  <div class="form-wrapper">
    <form id="iframes">

      <div class="form-row">
        <div class="card-name">
          <label for="iframesCardHolderName">{{ transloco('CardholderName') }}</label>
          <div id="iframesCardHolderName"></div>
          <div id="iframesCardHolderNameError" class="iframe-error" [hidden]="!iframesCardHolderNameError">{{ transloco('CardholderNameRequired') }}</div>
        </div>

        <div class="amount">
          <index-text-input
            #indexRequestedAmount
            label="{{ transloco('Amount') }}"
            input-id="iframesAmount"
            ngDefaultControl
            name="amount"
            max="{{balanceDueFixedPointFormat}}"
            maxlength="10"
            [(ngModel)]="this.paymentData.RequestedAmount"
          ></index-text-input>
        </div>
      </div>

      <div class="form-row">
        <div class="card-number">
          <label for="iframesCardNumber">{{ transloco('CardNumber') }}</label>
          <div id="iframesCardNumber"></div>
          <div id="iframesCardNumberError" class="iframe-error" [hidden]="!iframesCardNumberError">{{ transloco('CardNumberRequired') }}</div>
        </div>

        <div class="card-expiration">
          <label for="iframesCardExpiration">{{ transloco('Expiration') }}</label>
          <div id="iframesCardExpiration"></div>
          <div id="iframesCardExpirationError" class="iframe-error" [hidden]="!iframesCardExpirationError">{{ transloco('CardExpirationRequired') }}</div>
        </div>
  
        <div class="card-security">
          <label for="iframesCardCvv">{{ transloco('SecurityCode') }}</label>
          <div id="iframesCardCvv"></div>
          <div id="iframesCardCvvError" class="iframe-error" [hidden]="!iframesCardCvvError">{{ transloco('CardSecurityCodeRequired') }}</div>
        </div>
      </div>

      <h3 class="subheading col-span-3 w-auto float-left clear-left">{{ transloco('BillingAddress') }}</h3>

       <index-button class="clear-address float-right clear-right"
                     type="quick"
                     (click)="this.handleClearAddressClick()">{{ transloco('ClearAddress') }}</index-button>

       <hr class="clear-both">

       <div class="form-row">
        <div class="billing-address1">
          <index-text-input #indexBillingAddress1 label="{{ transloco('StreetAddress1') }}" input-id="iframesStreetAddress1" ngDefaultControl name="address1" maxlength="100" [(ngModel)]="this.paymentData.StreetAddress1"></index-text-input>
        </div>

        <div class="billing-address2">
          <index-text-input #indexBillingAddress2 label="{{ transloco('StreetAddress2') }}" input-id="iframesStreetAddress2" ngDefaultControl name="address2" maxlength="100" [(ngModel)]="this.paymentData.StreetAddress2"></index-text-input>
        </div>
      </div>

      <div class="form-row">
        <div class="billing-city">
          <index-text-input #indexCity label="{{ transloco('City') }}" input-id="iframesCity" name="city" maxlength="100" ngDefaultControl [(ngModel)]="this.paymentData.City"></index-text-input>
        </div>

        <div class="billing-state">
          <index-text-input #indexState label="{{ invoiceRegionType | uppercase }}" input-id="iframesState" name="state" maxlength="2" ngDefaultControl [(ngModel)]="this.paymentData.StateCode"></index-text-input>
        </div>

        <div class="billing-postal-code">
          <index-text-input #indexAddressBillingZip label="{{ transloco('PostalCode') }}" input-id="iframesAddressBillingZip" ngDefaultControl name="postalcode" [(ngModel)]="this.paymentData.PostalCode"></index-text-input>
        </div>
      </div>

      <div id="iframesSubmit"></div>
    </form>
  </div>
 </section>
</section>

